import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Resolve an image path returned by the backend (starts with /uploads/...)
export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http")) return u;
  return `${BACKEND_URL}${u}`;
};

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((cfg) => {
  const t = typeof window !== "undefined" ? localStorage.getItem("melavi_admin_token") : null;
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fetchProducts = async (params = {}) => (await api.get("/products", { params })).data;
export const fetchProduct = async (slug) => (await api.get(`/products/${slug}`)).data;
export const fetchMotifs = async () => (await api.get("/motifs")).data;
export const fetchLocation = async () => (await api.get("/settings/location")).data;
export const postContact = async (data) => (await api.post("/contact", data)).data;
export const postOrder = async (data) => (await api.post("/orders", data)).data;
export const checkPincode = async (pincode) =>
  (await api.get("/shipping/check-pincode", { params: { pincode } })).data;
export const verifyRazorpay = async (data) => (await api.post("/razorpay/verify", data)).data;
export const adminLogin = async (data) => (await api.post("/admin/login", data)).data;

// ---------- admin helpers ----------
export const adminMe = async () => (await api.get("/admin/me")).data;
export const adminListProducts = async () => (await api.get("/admin/products")).data;
export const adminGetProduct = async (slug) => (await api.get(`/admin/products/${slug}`)).data;
export const adminCreateProduct = async (data) => (await api.post("/admin/products", data)).data;
export const adminUpdateProduct = async (slug, patch) => (await api.put(`/admin/products/${slug}`, patch)).data;
export const adminDeleteProduct = async (slug) => (await api.delete(`/admin/products/${slug}`)).data;
export const adminUploadImage = async (slug, file, role = "main", caption = "") => {
  const fd = new FormData();
  fd.append("file", file);
  fd.append("role", role);
  fd.append("caption", caption);
  const t = localStorage.getItem("melavi_admin_token");
  const res = await fetch(`${API}/admin/products/${slug}/images`, {
    method: "POST",
    headers: { Authorization: `Bearer ${t}` },
    body: fd,
  });
  if (!res.ok) throw new Error((await res.text()) || `Upload failed (${res.status})`);
  return res.json();
};
export const adminDeleteImage = async (slug, url) =>
  (await api.delete(`/admin/products/${slug}/images`, { data: { url } })).data;
export const adminReorderImages = async (slug, urls) =>
  (await api.put(`/admin/products/${slug}/images/reorder`, { urls })).data;
export const adminUpdateImage = async (slug, patch) =>
  (await api.patch(`/admin/products/${slug}/images`, patch)).data;

// ---------- admin: GA4 analytics ----------
export const adminGa4Check = async () => (await api.get("/admin/analytics-check")).data;
export const adminGa4Realtime = async () => (await api.get("/admin/analytics/realtime")).data;
export const adminGa4Summary = async (range = "28days") =>
  (await api.get("/admin/analytics/summary", { params: { range } })).data;
export const adminGa4Pages = async (range = "28days") =>
  (await api.get("/admin/analytics/pages", { params: { range } })).data;
export const adminGa4Sources = async (range = "28days") =>
  (await api.get("/admin/analytics/sources", { params: { range } })).data;
